import { ReactNode } from 'react';

interface PlainTextProps {
  children: ReactNode;
}

function PlainText({ children }: PlainTextProps) {
  return (
    <div className="PlainText">
      <div className="Container">{children}</div>
    </div>
  );
}

export default PlainText;
